module.exports = __webpack_public_path__ + "img/coop.201373d4.svg";